<div class="content">
  <div class="form-login">
    <div class="main-title"><span>SatPhoneRecharge</span></div>
    <hr class="dashed-line">
    Logout in progress...
  </div>
</div>
